import { TypedDocumentNode } from 'providers/tanstack-query/types'
import { gql } from 'providers/tanstack-query/utils'
import { Data } from './types'

export const GET_PORTAL_TOKEN: TypedDocumentNode<Data> = gql`
  query getPortalToken {
    portalToken
  }
`
